module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_6005.96a38d57.png";